import React from "react";
import Navbarss from "../navbars/Navbarss";
import Map from "./Map";
import Footer from "../home/Footer";
import { FaLinkedinIn, FaTelegramPlane, FaYoutube } from "react-icons/fa";
import { RiWhatsappFill } from "react-icons/ri";
import { BsFacebook } from "react-icons/bs";

function Contactus() {
  return (
    <div>
      <Navbarss />
      <section class=" py-20 md:py-32 overflow-hidden">
        <img
          class="absolute top-0 left-0 md:mt-24"
          src="saturn-assets/images/contact/dots-side-1.svg"
          alt=""
        />
        <img
          class="absolute bottom-0 right-0 mb-8 lg:mb-24"
          src="saturn-assets/images/contact/dots-side-2.svg"
          alt=""
        />
        <div class=" container px-4 mx-auto">
          <div class="max-w-2xl mx-auto mb-18 text-center">
            <h1 class="font-heading text-5xl xs:text-6xl font-bold text-gray-900 mb-4">
              <span>Anything unclear or </span>
              <span class="font-serif italic">need help</span>
              <span>?</span>
            </h1>
            {/* <p class="text-xl text-gray-500 font-semibold">
              Relax, we are ready to support 24/7 for you
            </p> */}
          </div>
          <div class="flex flex-wrap justify-center -mx-4">
            <div class="w-full md:w-1/2 lg:w-auto px-4 xl:px-10 mb-10 md:mb-0">
              <div class="max-w-sm mx-auto mt-10 h-full py-8 px-6 bg-white border border-gray-200 rounded-5xl">
                <div class="max-w-2xs mx-auto text-center">
                  <img
                    class="block mx-auto mb-3"
                    src="saturn-assets/images/contact/icon-orange-email.svg"
                    alt=""
                  />
                  <h5 class="text-2xl font-bold text-gray-900 mb-3">
                    Contact us via our media.
                  </h5>
                  {/* <p class="text-gray-500 mb-3">
                    Contact us to seek help from us, we will help you as soon as
                    possible
                  </p> */}
                  <span class="block text-sm text-orange-900 mb-8">
                    Contactmeklitha@gmail.com
                  </span>

                  <div
                    className="flex justify-center space-x-6 animate__animated
                 animate__pulse animate__delay-1s animate__infinite mb-4"
                  >
                    <a
                      href="https://www.facebook.com/profile.php?id=61551149005409"
                      className="text-blue-500 hover:text-blue-400"
                    >
                      <BsFacebook className="h-5  w-5" />
                    </a>
                    <a
                      href="https://chat.whatsapp.com/CAKS6r20qulEzkd3CTCpYA"
                      className="text-blue-500 hover:text-blue-400"
                    >
                      <RiWhatsappFill className="h-5 w-5" />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/gebrheir-humaniterian-022453296"
                      className="text-blue-500 hover:text-blue-400"
                    >
                      <FaLinkedinIn className="h-5 w-5" />
                    </a>
                    <a
                      href="https://t.me/gebrheir"
                      className="text-blue-500 hover:text-blue-400"
                    >
                      <FaTelegramPlane className="h-5 w-5" />
                    </a>
                    <a
                      href="https://www.youtube.com/@Meklit Humanitarian Association Project"
                      className="text-blue-500 hover:text-blue-400"
                    >
                      <FaYoutube className="h-5 w-5" />
                    </a>
                  </div>
                  {/* <a
                    class="relative group inline-block py-4 px-6 text-white font-semibold bg-blue-400 rounded-full overflow-hidden"
                    href="https://gmail.com/"
                  >
                    <div class="absolute top-0 right-full w-full h-full bg-blue-500 transform group-hover:translate-x-full group-hover:scale-102 transition duration-500"></div>
                    <div class="relative flex items-center justify-center">
                      <span class="mr-4">
                        Contact To Meklit Humanitarian Association{" "}
                      </span>
                      <span>
                        <svg
                          width="8"
                          height="12"
                          viewbox="0 0 8 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.83 5.28999L2.59 1.04999C2.49704 0.956266 2.38644 0.881872 2.26458 0.831103C2.14272 0.780334 2.01202 0.754196 1.88 0.754196C1.74799 0.754196 1.61729 0.780334 1.49543 0.831103C1.37357 0.881872 1.26297 0.956266 1.17 1.04999C0.983753 1.23736 0.879211 1.49081 0.879211 1.75499C0.879211 2.01918 0.983753 2.27263 1.17 2.45999L4.71 5.99999L1.17 9.53999C0.983753 9.72736 0.879211 9.98081 0.879211 10.245C0.879211 10.5092 0.983753 10.7626 1.17 10.95C1.26344 11.0427 1.37426 11.116 1.4961 11.1658C1.61794 11.2155 1.7484 11.2408 1.88 11.24C2.01161 11.2408 2.14207 11.2155 2.26391 11.1658C2.38575 11.116 2.49656 11.0427 2.59 10.95L6.83 6.70999C6.92373 6.61703 6.99813 6.50643 7.04889 6.38457C7.09966 6.26271 7.1258 6.13201 7.1258 5.99999C7.1258 5.86798 7.09966 5.73728 7.04889 5.61542C6.99813 5.49356 6.92373 5.38296 6.83 5.28999Z"
                            fill="#FAFBFC"
                          ></path>
                        </svg>
                      </span>
                    </div>
                  </a> */}
                </div>
              </div>
            </div>
            <div class="w-full md:w-1/2 lg:w-auto px-4 xl:px-10">
              <div class="max-w-sm mx-auto mt-11 h-full py-8 px-6 bg-white border border-gray-200 rounded-5xl">
                <div class="max-w-2xs mx-auto text-center">
                  <img
                    class="block mx-auto mb-3"
                    src="saturn-assets/images/contact/icon-orange-headphones.svg"
                    alt=""
                  />
                  <h5 class="text-2xl font-bold text-gray-900 mb-3">
                    Contact us by phone
                  </h5>
                  <p class="text-gray-500 mb-3">
                    Call us if you need Information;
                  </p>
                  <span class="block text-sm text-orange-900 mb-4">
                    +251 11 4 710994 / +251 911 311346
                  </span>
                  <span class="block text-sm text-orange-900 mb-8">
                    +251940129248
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div>
        <Map />
      </div>
      <div className="pt-8 ">
        <Footer />
      </div>
    </div>
  );
}

export default Contactus;
